import * as type from './personalizedStudyActionTypes';

export const getAvailableChapters = (rate) => ({
  type: type.GET_AVAILABLE_CHAPTERS,
  rate,
});

export const setAvailableChapters = (chapters) => ({
  type: type.SET_AVAILABLE_CHAPTERS,
  chapters,
});

export const setAvailableChaptersLoading = (loading) => ({
  type: type.SET_AVAILABLE_CHAPTERS_LOADING,
  loading,
});

export const saveSelectedChapters = (chapters) => ({
  type: type.SAVE_SELECTED_CHAPTERS,
  chapters,
});

export const setSaveChaptersLoading = (loading) => ({
  type: type.SET_SAVE_CHAPTERS_LOADING,
  loading,
});

export const buildChapterStudyPlan = (startDate, examDate) => ({
  type: type.BUILD_CHAPTER_STUDY_PLAN,
  startDate,
  examDate,
});

export const setBuildChapterStudyPlanLoading = (loading) => ({
  type: type.SET_BUILD_CHAPTER_STUDY_PLAN_LOADING,
  loading,
});

export const loadChapterStudyPlan = () => ({
  type: type.LOAD_CHAPTER_STUDY_PLAN,
});

export const setChapterStudyPlan = (plan) => ({
  type: type.SET_CHAPTER_STUDY_PLAN,
  plan,
});
